export default __webpack_public_path__ + "static/media/maestro_reminder_bg.4a6efa96.png";